module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid6_800x798.895aa7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid6_800x798.jpg
// module id = Q538
// module chunks = 0